import {WinPresentationController} from "../../WinPresentationController";
import {DDay} from "../../../DDay";
import {BelowStakeWinRestriction} from "../../../server/BelowStakeWinRestriction";
import {BlitzKriegSound} from "../../../sound/BlitzKriegSound";
import {BlitzKriegParsedGameData} from "../../../server/data/BlitzKriegParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TimelineLite} from "gsap";

export class InitialWinCountUpController extends WinPresentationController {
    private _belowStakeWinRestriction: boolean;

    constructor() {
        super("InitialWinCountUpController", false);
    }

    protected hasWin(): boolean {
        return DDay.model.parsedGameData.betWins?.length > 0 && DDay.model.parsedGameData.currentWinRatioConfig!.bigWinLevel < 0;
    }

    protected async createWinAnimation(): Promise<any> {
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue();
        const tl: TimelineLite = new TimelineLite();
        tl.add(this.getWinAnimation());
        await Promise.resolve(tl);
    }

    protected getWinAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (!this._belowStakeWinRestriction) {
            // TODO: play sound.
            let countUpTl: TimelineLite = this.getWinCountUpAnimation();
            tl.add(countUpTl);
        } else {
            tl.add(() => {
                const data: BlitzKriegParsedGameData = DDay.model.parsedGameData;
                SlotGame.keypadPlugin.setWin(data.totalWin, data.showTotalWin, BelowStakeWinRestriction.isWinBelowStake());
            });
        }
        return tl;
    }

    protected getWinCountUpAnimation(): TimelineLite {
        const data: BlitzKriegParsedGameData = DDay.model.parsedGameData;
        const tl: TimelineLite = new TimelineLite();
        if (data.currentWinRatioConfig!.bigWinLevel > -1) {
            return tl; // no count up for big win.
        }

        if (!this._belowStakeWinRestriction) {
            // TODO: if play sound inside the count up, pass in this._belowStakeWinRestriction to the countup.
            tl.add([DDay.initialCountUp.getCountUpAnimation(0, data.singleWin, data.currentWinRatioConfig!.duration, data.currentMultiplier, data.totalWays), () => {
                if (DDay.model.parsedGameData.currentWinRatioConfig?.index === 2 || DDay.model.parsedGameData.currentWinRatioConfig?.index === 3) {
                    BlitzKriegSound.playTrack({name: BlitzKriegSound.WIN_COUNT_UP});
                }
            }]);
        }

        tl.add(() => {
            SlotGame.keypadPlugin.setWin(data.totalWin, data.showTotalWin, BelowStakeWinRestriction.isWinBelowStake());
        });

        return tl;
    }

}
